'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Add = require('./Add.js');
var CheckMark = require('./CheckMark.js');
var CheckMarkCircleOutlined = require('./CheckMarkCircleOutlined.js');
var CheckMarkCircleFilled = require('./CheckMarkCircleFilled.js');
var Exchange = require('./Exchange.js');
var ExclamationCircleFilled = require('./ExclamationCircleFilled.js');
var Package = require('./Package.js');
var PlaceholderPictures = require('./PlaceholderPictures.js');
var PlaceholderThumbnail = require('./PlaceholderThumbnail.js');
var XCircleFilled = require('./XCircleFilled.js');
var InfoCircle = require('./InfoCircle.js');
var IndeterminateCircleFilled = require('./IndeterminateCircleFilled.js');
var OpenInNew = require('./OpenInNew.js');
var Sparkles = require('./Sparkles.js');
var Radio = require('./Radio.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Clock = require('./Clock.js');
var MagnifyingGlass = require('./MagnifyingGlass.js');
var Folder = require('./Folder.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const icons = {
  Add: Add["default"],
  CheckMark: CheckMark["default"],
  CheckMarkCircleOutlined: CheckMarkCircleOutlined["default"],
  CheckMarkCircleFilled: CheckMarkCircleFilled["default"],
  Clock: Clock["default"],
  Exchange: Exchange["default"],
  ExclamationCircleFilled: ExclamationCircleFilled["default"],
  IndeterminateCircleFilled: IndeterminateCircleFilled["default"],
  Package: Package["default"],
  PlaceholderPictures: PlaceholderPictures["default"],
  PlaceholderThumbnail: PlaceholderThumbnail["default"],
  XCircleFilled: XCircleFilled["default"],
  InfoCircle: InfoCircle["default"],
  RadioSelected: Radio.RadioSelected,
  RadioUnselected: Radio.RadioUnselected,
  OpenInNew: OpenInNew["default"],
  Sparkles: Sparkles["default"],
  MagnifyingGlass: MagnifyingGlass["default"],
  Folder: Folder["default"]
};
const Icon = _ref => {
  let {
    icon,
    ...props
  } = _ref;
  return icons[icon](props);
};
const IconThemedRoot = props => {
  const {
    iconsPrimaryNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(Icon, _extends__default["default"]({
    style: {
      fill: iconsPrimaryNone === null || iconsPrimaryNone === void 0 ? void 0 : iconsPrimaryNone.color
    }
  }, props));
};
const IconThemed = nthHookTheme.withThemeProvider(IconThemedRoot, {
  themeTokens: ['iconsPrimaryNone']
});

exports.IconThemed = IconThemed;
exports["default"] = Icon;
exports.icons = icons;
